<p-dialog [visible]="open()" (visibleChange)="closeDialog()" [header]="header()" [blockScroll]="true">
    <div class="mb-3">
        <span class="fs-3">
            <i class="bi bi-exclamation-triangle-fill"></i>
        </span>
        <span>
            {{message()}}
        </span>
    </div>

    <div class="d-flex flex-row gap-1 w-100 justify-content-end">
        <i-button [styleClass]="'red '" [icon]="'bi bi-x'" [text]="'global.cancel' | translate"
            (click)="cancel()"></i-button>
        <i-button [styleClass]="'blue '" [icon]="'bi bi-check'" [text]="'global.confirm' | translate"
            (click)="confirm()"></i-button>
    </div>

</p-dialog>